module.exports = require("core-js/library/fn/array/from");


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap/~/@babel/runtime/core-js/array/from.js
// module id = 382
// module chunks = 35783957827783 114276838955818